var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientSunLogoOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 0.400009L17.9 4.2C19.4 5.6 20.2 7.50001 20.2 9.60001C20.2 11.6 21 13.5 22.4 14.9L22.9 15.4L27.5 0.5",
    fill: "url(#paint0_linear-973576)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 13.7L5.80005 13.5C7.80005 13.4 9.80004 14.2 11.2 15.6C12.6 17 14.5 17.7 16.5 17.7H17.2L9.80005 4",
    fill: "url(#paint1_linear-038863)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300003 32.7L4 28.7C5.4 27.2 7.3 26.3 9.3 26.3C11.3 26.3 13.1 25.4 14.5 24L15 23.5L0 19.2",
    fill: "url(#paint2_linear-349313)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 45.9L13.6 40.4C13.5 38.4 14.2 36.4 15.6 34.9C16.9 33.5 17.7 31.5 17.6 29.6V28.9L4 36.6",
    fill: "url(#paint3_linear-668705)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 45.5L28.8 41.9C27.3 40.6 26.4 38.7 26.3 36.6C26.2 34.6 25.3 32.8 23.9 31.4L23.4 30.9L19.4 46",
    fill: "url(#paint4_linear-177612)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 31.6L40.4 32C38.4 32.2 36.4 31.5 34.9 30.1C33.4 28.8 31.5 28.1 29.5 28.2H28.8L36.8 41.6",
    fill: "url(#paint5_linear-288907)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 12.7L41.5 16.9C40.2 18.4 38.3 19.4 36.3 19.5C34.3 19.6 32.5 20.5 31.2 22L30.8 22.5L46 26.1",
    fill: "url(#paint6_linear-993914)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 0L31.4 5.5C31.6 7.5 31 9.50001 29.6 11.1C28.3 12.6 27.7 14.5 27.8 16.5L27.9 17.2L41.1 8.90001",
    fill: "url(#paint7_linear-456591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear-973576",
    x1: 28.9243,
    y1: -6.96503,
    x2: 3.75797,
    y2: 12.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear-038863",
    x1: 18.9699,
    y1: -2.72674,
    x2: -4.66831,
    y2: 22.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear-349313",
    x1: 16.5708,
    y1: 12.5715,
    x2: -6.74592,
    y2: 34.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear-668705",
    x1: 19.0335,
    y1: 20.553,
    x2: -8.44767,
    y2: 39.5268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear-177612",
    x1: 34.3138,
    y1: 23.4859,
    x2: 9.06757,
    y2: 42.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear-288907",
    x1: 47.6908,
    y1: 21.6065,
    x2: 24.6141,
    y2: 46.9881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear-993914",
    x1: 47.5918,
    y1: 6.12056,
    x2: 24.4324,
    y2: 28.7789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear-456591",
    x1: 42.494,
    y1: -8.44524,
    x2: 15.0343,
    y2: 9.88334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientSunLogoOne);
export default __webpack_public_path__ + "static/media/GradientSunLogoOne.fc8d8a63.svg";
export { ForwardRef as ReactComponent };